import { IShopifyAddress } from '../interfaces'

export const isValidAddress = (address: IShopifyAddress): boolean => {
  const { city, country_code, province_code } = address
  return !!(city && country_code && province_code)
}
